export default "__VITE_ASSET__8412c85f__"